import dayjs from "dayjs"
import { useEffect, useState } from "react"

import { type AppVersion } from "./interfaces"

const TOOLTIP_DATE_FORMAT = "MMMM D, YYYY HH:mm"

function transformVersionData(data: AppVersion): AppVersion {
  try {
    const transformVersionData = {
      ...data,
      deployDate: dayjs(data.deployDate).format(TOOLTIP_DATE_FORMAT),
      commitDate: dayjs(data.commitDate).format(TOOLTIP_DATE_FORMAT),
    }

    return transformVersionData
  } catch (error) {
    console.error("Error transforming version data:", error)
  }

  return data
}

export function useVersion(): { version: AppVersion | null } {
  const [version, setVersion] = useState<AppVersion | null>(null)

  useEffect(() => {
    const cacheBuster = Date.now()
    fetch(`/version.json?cb=${cacheBuster}`)
      .then((res) => res.json())
      .then((data: AppVersion) => {
        setVersion(transformVersionData(data))
      })
      .catch((error) => {
        console.error("Error fetching version data:", error)
      })
  }, [])

  return { version }
}
